import mediator from "@tvg/mediator";

import uamService from "@tvg/api/uam";
import cookie from "react-cookie";

export const onPageViewGtmEvent = (location) => {
  const accountId = cookie.load("userId");

  if (accountId) {
    uamService
      .getUserProfile(accountId)
      .then((response) =>
        mediator.base.dispatch({
          type: "REGISTRATION:PAGE_VIEW",
          payload: {
            location,
            accountId,
            loginStatus: "Logged In",
            residenceState: response.data.homeAddress.stateAbbr
          }
        })
      )
      .catch(() =>
        mediator.base.dispatch({
          type: "REGISTRATION:PAGE_VIEW",
          payload: {
            location,
            accountId,
            loginStatus: "Logged Out",
            residenceState: ""
          }
        })
      );
  } else {
    mediator.base.dispatch({
      type: "REGISTRATION:PAGE_VIEW",
      payload: {
        location,
        accountId: "",
        loginStatus: "Logged Out",
        residenceState: ""
      }
    });
  }
};

export const onVirtualPageViewGtmEvent = (location, view) =>
  mediator.base.dispatch({
    type: "REGISTRATION:VIRTUAL_PAGE_VIEW",
    payload: {
      location,
      view,
      accountId: "",
      loginStatus: "Logged Out",
      residenceState: ""
    }
  });
